import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";

import ClientSelector from "../ClientSelector";
import GlobalShipmentSearch from "../GlobalShipmentSearch";
import HamburgerIcon from "./hamberger";
import { MobileSideDrawer } from "../SideNav";
import logo from "../../assets/logo.png";

export default function HeaderNew() {
  const navigate = useNavigate();
  const location = useLocation();
  const accessor = useSelector(state => state.accessor.accessor);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <>
      <nav
        className={`relative z-30 bg-white border-b border-grey-100 shrink-0 ${
          accessor ? "" : "lg:hidden"
        }`}>
        <div className='mx-auto px-3 sm:px-5'>
          {accessor ? (
            <div className='flex flex-col gap-2 py-2 lg:py-0 lg:h-16 lg:flex-row lg:items-center lg:gap-3'>
              <div className='flex lg:hidden items-center gap-2 min-h-[2.5rem]'>
                <button
                  type='button'
                  onClick={() => setMobileOpen(true)}
                  aria-label='Open main menu'
                  aria-expanded={mobileOpen}
                  className='inline-flex items-center justify-center p-2 -ml-1.5 rounded-lg text-grey-700 hover:text-grey-900 hover:bg-grey-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-main'>
                  <HamburgerIcon isOpen={mobileOpen} />
                </button>
                <button
                  type='button'
                  onClick={() => navigate("/")}
                  className='flex items-center min-w-0'
                  aria-label='Wiffy home'>
                  <img
                    src={logo}
                    alt='Wiffy'
                    className='h-5 w-auto max-w-[5.5rem] object-contain'
                  />
                </button>
              </div>

              <div className='flex flex-1 min-w-0 items-center gap-2 lg:gap-3'>
                <div
                  className='w-[9.5rem] sm:w-52 lg:w-72 shrink-0 empty:hidden'>
                  <ClientSelector variant='header' />
                </div>
                <div className='flex-1 min-w-0 max-w-3xl'>
                  <GlobalShipmentSearch />
                </div>
              </div>
            </div>
          ) : (
            <div className='flex items-center gap-2 h-14 lg:hidden'>
              <button
                type='button'
                onClick={() => navigate("/")}
                className='flex items-center min-w-0'
                aria-label='Wiffy home'>
                <img
                  src={logo}
                  alt='Wiffy'
                  className='h-5 w-auto max-w-[5.5rem] object-contain'
                />
              </button>
            </div>
          )}
        </div>
      </nav>

      <MobileSideDrawer
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />
    </>
  );
}
